import { type RowData } from '@tanstack/react-table';
import { type LegacyColumn as Column } from '@tanstack/react-table/legacy';

type ColGroupProps<TData extends RowData> = {
  columns: Column<TData>[];
};

export const ColGroup = <TData extends RowData>({ columns }: ColGroupProps<TData>) => {
  return (
    <colgroup>
      {columns.map((column) => {
        if ('accessorKey' in column.columnDef) {
          return (
            <col
              key={column.columnDef.accessorKey.toString()}
              style={{ width: column.columnDef.size }}
            />
          );
        }

        return <col key={column.id} style={{ width: column.columnDef.size }} />;
      })}
    </colgroup>
  );
};
